import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RecommendationState } from '@urbannex/product-multi-recommender/lib/core/types';
import { NbCardModule,NbButtonModule,NbInputModule,NbIconModule,NbSpinnerModule,NbFormFieldModule, NbSelectModule, NbCheckboxModule, NbLayoutModule } from '@nebular/theme';

@Component({
  selector: 'ubs-input-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    NbIconModule,
    NbSpinnerModule,
    NbFormFieldModule,
    NbSelectModule,
    NbCheckboxModule,
    NbLayoutModule],
  templateUrl: './input-panel.component.html',
  styleUrls: ['./input-panel.component.scss']
})
export class InputPanelComponent implements OnChanges{
  
  @Input() currentStep: RecommendationState['currentStep'] = 'category';
  @Input() isLoading: boolean = false;
  @Input() hasSelections:boolean;
  @Input() hasMessages:boolean;
  @Input() categories: any[] = []; // Still keep this for future use
  @Input() features: string[] = [];
  @Output() textSubmit = new EventEmitter<string>();
  @Output() imageSubmit = new EventEmitter<File>();
  @Output() categoryDescriptionSubmit = new EventEmitter<string>();
  @Output() featuresSelect = new EventEmitter<string[]>();
  @Output() productListSubmit = new EventEmitter<string>();

  catalogInput:string = '';
  categoryInput: string = '';
  selectedCategory: string | null = null;
  selectedFeatures: string[] = [];
  descriptionText: string = '';
  selectedFile: File | null = null;
  previewUrl: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['hasMessages']) {
      console.log('hasMessages changed:', this.hasMessages);
    }
  }

  getHeaderText(): string {
    switch (this.currentStep) {
      case 'category':
        return 'Product Description';
      case 'features':
        return 'Choose Features';
      case 'description':
        return 'Detailed Requirements';
      case 'catalog':
        return "Let's create your catalog"
      default:
        return 'Input';
    }
  }

  onProductDescriptionSubmit(): void {
    console.log('categoryInput',this.categoryInput);
    this.categoryDescriptionSubmit.emit(this.categoryInput);
    /* if (this.categoryInput.trim()) {
      this.categoryDescriptionSubmit.emit(this.categoryInput);
    } */
  }

  onProductListSubmit():void{
    console.log('catalogInput',this.catalogInput);
    this.productListSubmit.emit(this.catalogInput);
  }

  onFeaturesSelect(): void {
    this.featuresSelect.emit(this.selectedFeatures);
  }

  onTextSubmit(): void {
    if (this.descriptionText.trim()) {
      this.textSubmit.emit(this.descriptionText);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.createImagePreview();
    }
  }

  createImagePreview(): void {
    if (this.selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result as string;
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  removeFile(): void {
    this.selectedFile = null;
    this.previewUrl = null;
  }

  onImageSubmit(): void {
    if (this.selectedFile) {
      this.imageSubmit.emit(this.selectedFile);
    }
  }

  toggleFeature(feature: string): void {
    const index = this.selectedFeatures.indexOf(feature);
    if (index === -1) {
      this.selectedFeatures.push(feature);
    } else {
      this.selectedFeatures.splice(index, 1);
    }
  }

  isFeatureSelected(feature: string): boolean {
    return this.selectedFeatures.includes(feature);
  }

}
